import type { ComponentProps } from 'react';
import { cn } from '../../utils/cn';
import { Image } from '../Image/Image';

type BlogArticleInlineImageProps = ComponentProps<typeof Image>;

export const BlogArticleInlineImage = ( { className, ...imgAttributes }: BlogArticleInlineImageProps ) => {

  return (
    <Image
      className={ cn( 'aspect-[720/468] object-cover', className ) }
      { ...imgAttributes }
    />
  )
}
BlogArticleInlineImage.displayName = 'BlogArticleInlineImage';
